<template>
  <v-dialog v-model="dialogProxy" width="550">
    <v-card
      v-if="dataAluno && dataAluno.length > 0 && !dataAluno[0].status_solicitacao && dataAluno[0].cpf"
      >
        <v-toolbar dark color="primary d-flex justify-center"> Informações </v-toolbar>
        <v-card-text class="mt-5 p-0">
          <div class="text flex-column d-flex justify-center mt-3">
            <p class="text-center">
              <v-icon x-large color="amber darken-2 " aria-hidden="true"
                >fa fa-exclamation-triangle</v-icon
              >
            </p>
            <strong class="text-center">{{dataAluno[0].mensagem  }} </strong>
            <p class=" text-center mt-0 mb-0"></p>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn class="my-2"
                   text
                   color="primary" @click="closeDialog()">Ok</v-btn>
        </v-card-actions>
      </v-card>
    <v-card
      v-if="dataAluno && dataAluno.length > 0 && dataAluno[0].status_solicitacao === 'PRÉ-SOLICITADO'"
      >
        <v-toolbar dark color="primary d-flex justify-center"> Informações </v-toolbar>
        <v-card-text class="mt-5 p-0">
          <div class="text flex-column d-flex justify-center mt-3">
            <p class="text-center">
              <v-icon x-large color="green darken-2 " aria-hidden="true"
                >fa fa-check-square fa-4x</v-icon
              >
            </p>
            <p class=" text-center mb-0">
              <strong>{{ dataAluno[0].aluno_nome }},</strong> seu pré-cadastro já está autorizado.
            </p>
            <p class="text-center"> </p>
            <p class=" text-center mt-0 mb-0"> Aguarde a confecção da Carteira do VAIVEM que em breve informaremos o posto do Detran para a retirada.</p>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn class="my-2"
                   text
                   color="primary" @click="closeDialog()">Ok</v-btn>
        </v-card-actions>
      </v-card>
      <v-card
        v-if="dataAluno && dataAluno.length > 0 && dataAluno[0].status_solicitacao === 'SOLICITADO'"
      >
        <v-toolbar dark color="primary"> Informações </v-toolbar>
        <v-card-text class="mt-5 p-0">
          <div class="text flex-column justify-center mt-3">
            <p class="text-center">
              <v-icon x-large color="green darken-2 " aria-hidden="true"
                >fa fa-check-square fa-4x</v-icon
              >
            </p>
            <p class="text-justify mb-0">
              <strong>{{ dataAluno[0].aluno_nome }}</strong
              >, seu pré-cadastro já está autorizado. Dirija-se ao endereço
              <strong>{{ dataAluno[0].endereco_posto }}</strong>, portando documento de identificação com foto.
            </p>
            <p class="mt-0 mb-0 text-justify"></p>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn class="my-2"
                   text
                   color="primary" @click="closeDialog()">Ok</v-btn>
        </v-card-actions>
      </v-card>
      <v-card
        v-if="dataAluno && dataAluno.length > 0 && dataAluno[0].status_solicitacao === 'ENTREGUE'"
      >
        <v-toolbar dark color="primary"> Informações </v-toolbar>
        <v-card-text class="mt-5 p-0">
          <div class="text flex-column justify-center mt-3">
            <p class="text-center">
              <v-icon x-large color="green darken-2 " aria-hidden="true"
                >fa fa-check-square fa-4x</v-icon
              >
            </p>
            <p class="text-justify mb-0">
              Carteira retirada por
              <strong>{{ dataAluno[0].aluno_nome }}</strong> no endereço
              <strong>{{ dataAluno[0].endereco_posto }}</strong>.
            </p>
            <p>
              A entrega foi realizada por
              <strong>{{ dataAluno[0].nome_usuario_seguranca_entrega }}</strong> no dia
              <strong>{{ formatDate(dataAluno[0].data_entrega) }}</strong
              >.
            </p>
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn @click="closeDialog()">Fechar</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import * as _ from "lodash";
import dayjs from "dayjs";

export default {
  name: "ModalResultadoEstudante",
  props: {
    dataAluno: Array,
    dialog: Boolean,
  },
  components: {},
  data() {
    return {
      aluno: [],
      openDialog: false,
    };
  },
  computed: {
    dialogProxy: {
    get() {
      return this.dialog;
    },
    set(value) {
      this.$emit("update:dialog", value);
    },
  },
  alunoPrincipal() {
    return this.dataAluno?.[0] || {};
  }
},
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);  
      this.$emit("closeDialog", false); 
    },
    formatDate(date) {
      const formatDate = dayjs(date).format("DD/MM/YYYY");
      return formatDate;
    },
  },
};
</script>
<style></style>
